import DarkMode from '@mui/icons-material/DarkMode';
import LightMode from '@mui/icons-material/LightMode';
import { IconButton, Tooltip } from '@mui/material';

import { useColorMode } from '../theme/ColorMode.js';

/**
 * AppBar-friendly button that flips between light + dark modes.
 * Mode is persisted to localStorage via the ColorMode context.
 */
export function ColorModeToggle() {
  const { mode, toggleMode } = useColorMode();
  const next = mode === 'dark' ? 'light' : 'dark';
  return (
    <Tooltip title={`Switch to ${next} mode`}>
      <IconButton onClick={toggleMode} size="small" aria-label={`Switch to ${next} mode`}>
        {mode === 'dark' ? <LightMode fontSize="small" /> : <DarkMode fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
